import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  return (
    <nav className='fixed nav w-full top-4 py-1 z-50'>
      <ul className='flex flex-row justify-center  md:space-x-10  md:text-xl font-thin'>
        <li>
          <Link to='/' className='py-1 px-3 lg:px-5 hover:bg-gray focus:bg-gray rounded-lg'>
            <a href='#app'>Home</a>
          </Link>
        </li>
        <li>
          <a href='#projects' className='py-1 px-3 lg:px-5 hover:bg-gray focus:bg-gray rounded-lg'>
            Projects
          </a>
        </li>
        <li>
          <a href='#about' className='py-1 px-3 lg:px-5 hover:bg-gray focus:bg-gray rounded-lg'>
            About
          </a>
        </li>
        <li>
          <Link to='/blogs' className='py-1 px-3 lg:px-5 hover:bg-gray focus:bg-gray rounded-lg'>Blogs</Link>
        </li>
        <li>
          <a href='https://drive.google.com/file/d/1PN9ALk1AOo_PVr8S5SU6TlYt4kBw1pRs/view?usp=share_link' className='py-1 outline-white px-3 lg:px-5 hover:bg-gray focus:bg-gray rounded-lg'>
            Resume
          </a>
        </li>
      </ul>
    </nav>
  );
};

export default Header;
